import { ActionTree } from 'vuex';
import { AdmpNewsState } from './types';
import { RootState } from '../../types';
import { ContactType, defaultBackendAdmpNews } from '@/shared/backend/admpNews';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import { Value, AdmpNews } from '@/shared/model/admpNews';
import { AxiosResponse } from 'axios';
import i18n from '@/i18n';
import DownloadUtils from '@/shared/utils/DownloadUtils';
import admpNewsSearchData from '@/shared/model/smallPayloadModels/admpNewsSearchData';
// import { CONST } from '../utils/Constants';
// payload?: { searchParams?: any; searchData?: any }
const logger = new Logger('actions.AdmpNews');
export const actions: ActionTree<AdmpNewsState, RootState> = {
  getAdmpNewsList(
    { commit, dispatch, getters, rootGetters },
    payload?: { searchParams?: any; admpNewsSearchData?: any; searchData?: any }
  ) {
    commit('setAdmpNewsIsLoading', true);
    console.log('zzz getAdmpNewsList payload :>> ', payload);
    const isUserInAzureAdminGroup = rootGetters['auth/isUserSupportOrSuperAdmin'];
    const contactForLoggedInUser = rootGetters['contact/getContactForLoggedInUser'];
    let admpnlNewsSearchData = (payload?.admpNewsSearchData || payload?.searchData) ?? admpNewsSearchData.defaultData();
    let searchParams = payload?.searchParams ?? getters.getAdmpNewsSearchParams;
    const finalSearchData = {
      ...admpnlNewsSearchData,
      isUserInAzureAdminGroup: isUserInAzureAdminGroup,
      contactRecordID: contactForLoggedInUser?.recordID ?? null,
    };
    // let organisationId = rootGetters[CONST.getOrganisation].id;
    return defaultBackendAdmpNews
      .getAdmpNewsList(searchParams, finalSearchData)
      .then((response: AxiosResponse<Value>) => {
        commit('setAdmpNews', response.data);
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => {
        commit('setAdmpNewsIsLoading', false);
      });
  },
  getAdmpNews({ commit, dispatch, rootGetters }, payload: { id: string; contactType: ContactType }) {
    const isUserInAzureAdminGroup = rootGetters['auth/isUserSupportOrSuperAdmin'];
    const contactForLoggedInUser = rootGetters['contact/getContactForLoggedInUser'];
    const finalSearchData = {
      ...payload,
      isAdmin: isUserInAzureAdminGroup,
      contactRecordID: contactForLoggedInUser?.recordID ?? null,
    };
    return defaultBackendAdmpNews
      .getAdmpNews(finalSearchData)
      .then((response: AxiosResponse<AdmpNews>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  updateAdmpNews({ commit, dispatch }, file: AdmpNews) {
    return defaultBackendAdmpNews
      .updateAdmpNews(file)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: AdmpNews;
          }>
        ) => {
          //module_utils.ok(i18n.tc(`success.News_update`), commit);
          return response.data;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  deleteAdmpNews({ commit, dispatch }, id: string) {
    return defaultBackendAdmpNews
      .deleteAdmpNews(id)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: AdmpNews;
          }>
        ) => {
          return response;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  async uploadNewsImage({ commit }, payload: any) {
    return await defaultBackendAdmpNews
      .uploadNewsDocument(payload)
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        module_utils.error(i18n.t(`error.upload_news_file`), commit, e, logger);
        throw e;
      });
  },

  async uploadNewsDocument({ commit }, payload: any) {
    const data = new FormData();
    data.append('File', payload.document, payload.document.name);
    data.append('Id', payload.id || 0);
    data.append('FileName', payload.FileName);
    data.append('BucketName', payload.BucketName);
    data.append('AdmpNewsId', payload.AdmpNewsId);
    // data.append('ParentId', payload.parentId || ''); //  Fix `undefined` error when upload from `Document-data` tab (NOT dialog)

    return await defaultBackendAdmpNews
      .uploadNewsDocument(data)
      .then((response) => {
        // module_utils.ok(i18n.t(`success.upload_news_file`), commit, logger);
        return response.data;
      })
      .catch((e) => {
        // commit('resetDocumentFile');
        module_utils.error(i18n.t(`error.upload_news_file`), commit, e, logger);
        throw e;
      });
  },
  async getNewsFileDownloadLink({ commit }, payload: any) {
    try {
      return await defaultBackendAdmpNews.getNewsFileDownloadLink(payload).then((response) => {
        console.log('getNewsFileDownloadLink response :>> ', response);
        let fileName = DownloadUtils.getFileName(response.headers['content-disposition']);
        const type = response.headers['content-type'];
        // console.log('filename, type :>> ', fileName, '----' , type);
        const blob = new Blob([response.data], { type: type });
        // console.log('blob :>> ', blob);
        if (payload.IsSaveOnDisk) {
          const url = DownloadUtils.createDownloadLink(blob, fileName);
          window.URL.revokeObjectURL(url);
          return fileName;
        }

        var urlCreator = URL.createObjectURL(blob);
        // module_utils.ok(i18n.t(`success.getNewsFileDownloadLink`), commit, logger);
        return urlCreator;
      });
    } catch (e) {
      // commit('resetDocumentFile');
      logger.error(e);
      module_utils.error(i18n.t(`error.getNewsFileDownloadLink`), commit, e, logger);
      throw e;
    }
  },

  async getNewsCountForUser({ commit, rootGetters }, payload: any) {
    return await defaultBackendAdmpNews
      .getNewsCountForUser(payload)
      .then((response) => {
        commit('setAdmpNewsContactType', payload.contactRecordID);
        commit('setUnreadNews', response.data);
        return response.data;
      })
      .catch((e) => {
        module_utils.error(i18n.t(`error.getNewsCountForUser`), commit, e, logger);
        throw e;
      });
  },
  async upsertAdmpNewsReadInfo({ commit }, payload: any) {
    return await defaultBackendAdmpNews
      .upsertAdmpNewsReadInfo(payload)
      .then((response) => {
        commit('setNewsInfo', response.data.result);
        return response.data;
      })
      .catch((e) => {
        module_utils.error(i18n.t(`error.upsertAdmpNewsReadInfo`), commit, e, logger);
        throw e;
      });
  },

  async getAdmpNewsNewsFiles({ commit }, id: number) {
    return await defaultBackendAdmpNews
      .getAdmpNewsFiles(id)
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        module_utils.error(i18n.t(`error.getAdmpNewsCountForUser`), commit, e, logger);
        throw e;
      });
  },

  async updateAdmpNewsFile({ commit }, payload: any) {
    return await defaultBackendAdmpNews
      .updateAdmpNewsFile(payload)
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        // commit('resetDocumentFile');
        module_utils.error(i18n.t(`error.updateAdmpNewsFile`), commit, e, logger);
        throw e;
      });
  },
  async deleteAdmpNewsFile({ commit }, payload: any) {
    return await defaultBackendAdmpNews
      .deleteAdmpNewsFile(payload)
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        module_utils.error(i18n.t(`error.deleteAdmpNewsFile`), commit, e, logger);
        throw e;
      });
  },
  getDashboardAdmpNews({ commit, dispatch, getters, rootGetters }, payload?: any) {
    commit('setAdmpNewsDashboardIsLoading', true);
    return defaultBackendAdmpNews
      .getDashboardAdmpNews(payload)
      .then((response: AxiosResponse<AdmpNews>) => {
        commit('setAdmpNewsDashboard', response.data);
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => {
        commit('setAdmpNewsDashboardIsLoading', false);
      });
  },

  updateAdmpNewsSearchData({ commit, dispatch }, data: any) {
    console.log(
      '-----------action GetAdmpNewsList-----------updateAdmpNewsSearchData--------------------------------------  ===>>>  data ',
      data
    );
    commit('setAdmpNewsSearchData', data);
  },

  async updateUnreadNews({ commit }, value: any) {
    commit('setChangeUnreadNews', value);
  },
  async updateAdmpNewsImages({ commit }, value: any) {
    commit('setAdmpNewsImagesArr', value);
  },
  markAdmpNewsIsLoaded({ commit }) {
    commit('setAdmpNewsIsLoading', false);
  },
};
